module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SEEGA Contracting","short_name":"SEEGA","description":"SEEGA is Ottawa's premier residential and commercial painting company","start_url":"/","background_color":"#001818","theme_color":"#001818","icon":"src/images/favicon-orig.png","display":"standalone","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"5dff96507c294622db5f62c84abc84c9"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
